import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/money-market-calculator',
  component: () => import('../../routes/MoneyMarket.svelte'),
  card: {
    id: 'money-market',
    title: 'Money Market Calculator',
    description: 'Calculate growth of a money market account with monthly compounding and contributions.',
    icon: 'account_balance',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/money-market-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Money Market Account Calculator – Compound Growth with Monthly Contributions',
    description:
      'Calculate how much your money will grow in a money market account with monthly compounding and regular contributions. See year-by-year breakdown and effective APY.',
  },
};

export default meta;
